(function(){
  var reduce = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || false;
  var section = document.querySelector('section.media-sec');
  if (!section) return;
  var tabs = Array.prototype.slice.call(section.querySelectorAll('.f-tab'));
  var cards = Array.prototype.slice.call(section.querySelectorAll('.mcard'));
  var countEl = section.querySelector('#mediaCount');
  if(!tabs.length || !cards.length) return;

  function apply(tab){
    var cat = tab.getAttribute('data-filter');
    var label = tab.getAttribute('data-label');
    var shown = 0;
    cards.forEach(function(card){
      var match = (cat === 'all' || card.getAttribute('data-cat') === cat);
      card.classList.toggle('is-hidden', !match);
      if(match){
        shown++;
        if(!reduce){ card.classList.remove('just-shown'); void card.offsetWidth; card.classList.add('just-shown'); }
      }
    });
    if(countEl){ countEl.textContent = (cat === 'all') ? ('共 ' + shown + ' 篇報導') : (shown + ' 篇 · ' + label); }
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      tabs.forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      t.setAttribute('aria-pressed','true');
      apply(t);
    });
  });
})();
